import {
  CreateWebFunctionRequest,
  LambdaWebS3Object,
  LambdaWebFunctionCreateRequest,
  LambdaWebFunctionCreateOptions,
} from '@localstack/types';

/** Complete the API-shaped draft with provisioned resources and normalize numeric controls. */
export const buildWebFunctionRequest = (
  data: LambdaWebFunctionCreateRequest,
  { useKmsKey, configureConcurrency }: LambdaWebFunctionCreateOptions,
  code: LambdaWebS3Object,
  executionRoleArn: string,
): CreateWebFunctionRequest => {
  const { kmsKeyArn, serviceConfig, ...revision } = data.revisionConfig;
  const { maxConcurrencyPerEnvironment, ...service } = serviceConfig ?? {};
  const { regions, ...endpoint } = data.endpointConfig;
  return {
    ...data,
    revisionConfig: {
      ...revision,
      ...(useKmsKey && { kmsKeyArn }),
      buildConfig: { ...revision.buildConfig, codeConfig: { s3Object: code } },
      serviceConfig: {
        ...service,
        executionRoleArn,
        ...(configureConcurrency && {
          maxConcurrencyPerEnvironment: Number(maxConcurrencyPerEnvironment),
        }),
      },
    },
    endpointConfig: {
      ...endpoint,
      ...(endpoint.endpointType !== 'HomeRegion' && { regions }),
    },
  };
};
